// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address-line[data-v-74995a0f]{border-bottom:1px dashed #595a61}.address-line .line-item[data-v-74995a0f]{padding-bottom:0;padding-left:0}", ""]);
// Exports
module.exports = exports;
